export function requestTimeout() {
  let timeoutInMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new Promise((resolve, reject) => {
    if (timeoutInMs) {
      setTimeout(() => {
        const timeoutError = new Error("Request did not complete within ".concat(timeoutInMs, " ms"));
        timeoutError.name = "TimeoutError";
        reject(timeoutError);
      }, timeoutInMs);
    }
  });
}